import React from 'react';
interface ListItem {
  label: string | ReactNode;
  value: string | ReactNode;
  badge?: ReactNode;
}
interface ListWidgetProps {
  title: string;
  tooltipText?: string;
  items: ListItem[];
  updateTime: string;
  showViewMore?: boolean;
  onViewMore?: () => void;
}
export function ListWidget({
  title,
  tooltipText,
  items,
  updateTime,
  showViewMore = true,
  onViewMore
}: ListWidgetProps) {
  return <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2635">
      <div className="flex items-center gap-2 mb-4" data-id="element-2636">
        <h3 className="text-sm font-medium text-gray-700" data-id="element-2637">{title}</h3>
        {tooltipText && <button className="text-gray-400 hover:text-gray-600 group relative" data-id="element-2638">
            <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" data-id="element-2639">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" data-id="element-2640" />
              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" data-id="element-2641" />
            </svg>
            <div className="hidden group-hover:block absolute left-0 top-6 w-72 p-3 bg-gray-900 text-white text-xs text-left rounded shadow-lg z-10" data-id="element-2642">
              {tooltipText}
            </div>
          </button>}
      </div>
      <div className="space-y-3" data-id="element-2643">
        {items.map((item, index) => <div key={index} className={`flex justify-between items-center px-3 py-2 rounded hover:bg-blue-50 cursor-pointer transition-colors ${index < items.length - 1 ? 'border-b border-gray-200' : ''}`} data-id="element-2644">
            {typeof item.label === 'string' ? <span className="text-sm text-gray-600" data-id="element-2645">{item.label}</span> : item.label}
            {item.badge ? item.badge : typeof item.value === 'string' ? <span className="text-sm font-semibold text-gray-900" data-id="element-2646">
                {item.value}
              </span> : item.value}
          </div>)}
      </div>
      <div className="flex items-center justify-between mt-4" data-id="element-2647">
        <div className="text-xs text-gray-500" data-id="element-2648">{updateTime}</div>
        {showViewMore && <button onClick={onViewMore} className="text-sm text-blue-600 hover:text-blue-700" data-id="element-2649">
            View more
          </button>}
      </div>
    </div>;
}